import React from 'react';
import PropTypes from 'prop-types'


export class HtmlWrapper extends React.Component {
    render() {
        const { content } = this.props;
        return (
                    <table>
                        <tbody dangerouslySetInnerHTML={{ __html: content.toString() }}>
                        </tbody>
                    </table>
        )
    }
}

HtmlWrapper.propTypes = {
    content: PropTypes.string
}